module.exports = __webpack_public_path__ + "319ae62e9379054611fc644b1a7b39ea.pdf";